const bookPath = (bookId) => `/books/${encodeURIComponent(bookId)}`;
const appBookPath = (bookId) => `/app/books/${encodeURIComponent(bookId)}`;
export const wave2RoutePatterns = {
    capture: "/app/books/:bookId/capture",
    collaboration: "/app/books/:bookId/family",
    studio: "/app/books/:bookId/studio",
};
export const wave2Routes = {
    capture: (bookId) => `${appBookPath(bookId)}/capture`,
    collaboration: (bookId) => `${appBookPath(bookId)}/family`,
    studio: (bookId) => `${appBookPath(bookId)}/studio`,
};
export const wave2ApiRoutes = {
    capture: (bookId) => `${bookPath(bookId)}/capture`,
    captureCadence: (bookId) => `${bookPath(bookId)}/capture/cadence`,
    collaboration: (bookId) => `${bookPath(bookId)}/family-collaboration`,
    /** Sends an invitation to join a book, or sends a pending one again (E11). */
    invitations: (bookId) => `${bookPath(bookId)}/invitations`,
    studio: (bookId) => `${bookPath(bookId)}/studio`,
    studioPresentation: (bookId) => `${bookPath(bookId)}/studio/presentation`,
    studioExports: (bookId) => `${bookPath(bookId)}/studio/exports`,
    studioExport: (bookId, exportId) => `${bookPath(bookId)}/studio/exports/${encodeURIComponent(exportId)}`,
    studioExportDownload: (bookId, exportId) => `${bookPath(bookId)}/studio/exports/${encodeURIComponent(exportId)}/download`,
};
//# sourceMappingURL=wave2-routes.js.map